/**
 * Ajuda do Lance Fácil hospedada no EngageFacil.
 *
 * - Único lugar que monta a URL do artigo (montaUrlAjuda): as telas só referenciam a constante do slug.
 * - O slug é estável: depois de publicado o artigo, NÃO renomear (se a tela mudar de nome, muda-se só o texto).
 * - Todos os 142 artigos estão publicados no Engage (28/10). Para um artigo novo: acrescentar o slug em AJUDA_SLUGS
 *   e, se ele tiver `primary: true` numa rota, em AJUDA_POR_ROTA (a tabela vem do front matter em docs/ajuda/artigos).
 * - Atualizar este arquivo no mesmo commit do artigo (docs/ajuda/manifest.json é a lista oficial).
 */
import { reactive } from 'vue';

const AJUDA_BASE = 'https://app.engagefacil.com/help/lance-facil/article/';
const AJUDA_TENANT = 'e7d10ad7-af51-4437-bf86-50b03d77eb72';

/** URL do artigo de ajuda (abrir sempre em nova aba). */
export const montaUrlAjuda = (slug) => `${AJUDA_BASE}${encodeURIComponent(slug)}?tenantId=${AJUDA_TENANT}`;

/** Abre o artigo em nova aba. */
export const abrirAjuda = (slug) => {
    if (slug) window.open(montaUrlAjuda(slug), '_blank', 'noopener');
};

/** Slugs dos artigos publicados. */
export const AJUDA_SLUGS = Object.freeze({
    ALERTAS_ANEXOS_ITEM: 'alertas-anexos-item',
    ALERTAS_ATUALIZAR_VERIFICAR: 'alertas-atualizar-verificar',
    ALERTAS_CENTRAL: 'alertas-central',
    ALERTAS_CHAT_ONLINE: 'alertas-chat-online',
    ALERTAS_FILTROS_LISTA: 'alertas-filtros-lista',
    ALERTAS_ITENS_PREGAO: 'alertas-itens-pregao',
    ALERTAS_LER_MARCAR_LIDO: 'alertas-ler-marcar-lido',
    ALERTAS_PALAVRAS_CHAVE: 'alertas-palavras-chave',
    ALERTAS_PALAVRAS_CHAVE_CATALOGO: 'alertas-palavras-chave-catalogo',
    ALERTAS_SOM_NOTIFICACAO: 'alertas-som-notificacao',
    BOLETINS_CADASTRO: 'boletins-cadastro',
    BOLETINS_LISTA: 'boletins-lista',
    BUSCA_ANALISAR_IA: 'busca-analisar-ia',
    BUSCA_COLUNAS_PAGINACAO: 'busca-colunas-paginacao',
    BUSCA_DETALHE_EDITAL: 'busca-detalhe-edital',
    BUSCA_ENVIAR_PROPOSTA: 'busca-enviar-proposta',
    BUSCA_EXPORTAR_EXCEL: 'busca-exportar-excel',
    BUSCA_FAVORITOS: 'busca-favoritos',
    BUSCA_FILTROS: 'busca-filtros',
    BUSCA_ITENS_DOCUMENTOS: 'busca-itens-documentos',
    BUSCA_MODOS_VISUALIZACAO: 'busca-modos-visualizacao',
    BUSCA_NOTAS_EDITAL: 'busca-notas-edital',
    BUSCA_OPCOES: 'busca-opcoes',
    BUSCA_PALAVRAS_CHAVE: 'busca-palavras-chave',
    BUSCA_PESQUISAR: 'busca-pesquisar',
    BUSCA_SELECIONAR_PORTAIS: 'busca-selecionar-portais',
    CALENDARIO_ADICIONAR_EVENTO: 'calendario-adicionar-evento',
    CALENDARIO_EDITAR_EVENTO: 'calendario-editar-evento',
    CALENDARIO_PREGOES: 'calendario-pregoes',
    CONFIG_ALERTAS: 'config-alertas',
    CONFIG_ALERTAS_DISPOSITIVOS_MOBILE: 'config-alertas-dispositivos-mobile',
    CONFIG_CELULARES: 'config-celulares',
    CONFIG_CENTRAL_DECLARACOES: 'config-central-declaracoes',
    CONFIG_CENTRAL_EMPRESAS: 'config-central-empresas',
    CONFIG_DOCUMENTACAO_FINAL: 'config-documentacao-final',
    CONFIG_DOCUMENTACAO_MODELOS: 'config-documentacao-modelos',
    CONFIG_DOCUMENTACAO_RESPONSAVEIS: 'config-documentacao-responsaveis',
    CONFIG_DOCUMENTACAO_TIMBRE: 'config-documentacao-timbre',
    CONFIG_DOCUMENTOS_EMPRESA: 'config-documentos-empresa',
    CONFIG_DOCUMENTO_EMPRESA_ALERTAS: 'config-documento-empresa-alertas',
    CONFIG_DOCUMENTO_EMPRESA_BAIXAR: 'config-documento-empresa-baixar',
    CONFIG_DOCUMENTO_EMPRESA_CADASTRAR: 'config-documento-empresa-cadastrar',
    CONFIG_DOCUMENTO_EMPRESA_HISTORICO: 'config-documento-empresa-historico',
    CONFIG_DOCUMENTO_EMPRESA_RENOVAR: 'config-documento-empresa-renovar',
    CONFIG_GRADE_BUSCAR_EXPORTAR: 'config-grade-buscar-exportar',
    CONFIG_LOGINS_PORTAIS: 'config-logins-portais',
    CONFIG_LOGIN_PORTAL_CADASTRAR: 'config-login-portal-cadastrar',
    CONFIG_LOGIN_PORTAL_SITUACAO: 'config-login-portal-situacao',
    CONFIG_LOGS_SINCRONIA: 'config-logs-sincronia',
    CONFIG_LOGS_SINCRONIA_DETALHE: 'config-logs-sincronia-detalhe',
    CONFIG_REPRESENTADOS: 'config-representados',
    LANCES_BNC_BLL_LISTA: 'lances-bnc-bll-lista',
    LANCES_BNC_BLL_MINIMOS: 'lances-bnc-bll-minimos',
    LANCES_COMPRASNET_AUTOMACAO: 'lances-comprasnet-automacao',
    LANCES_COMPRASNET_CONFIG_ITEM: 'lances-comprasnet-config-item',
    LANCES_COMPRASNET_CONFIG_TODOS: 'lances-comprasnet-config-todos',
    LANCES_COMPRASNET_DETALHES: 'lances-comprasnet-detalhes',
    LANCES_COMPRASNET_DISPENSA_SALA: 'lances-comprasnet-dispensa-sala',
    LANCES_COMPRASNET_ITENS_ENCERRADOS: 'lances-comprasnet-itens-encerrados',
    LANCES_COMPRASNET_LANCES_ITEM: 'lances-comprasnet-lances-item',
    LANCES_COMPRASNET_LANCE_MANUAL: 'lances-comprasnet-lance-manual',
    LANCES_COMPRASNET_LISTA: 'lances-comprasnet-lista',
    LANCES_COMPRASNET_LOGS: 'lances-comprasnet-logs',
    LANCES_COMPRASNET_MENSAGENS: 'lances-comprasnet-mensagens',
    LANCES_COMPRASNET_MINIMOS: 'lances-comprasnet-minimos',
    LANCES_COMPRASNET_PREGAO_SALA: 'lances-comprasnet-pregao-sala',
    LANCES_PCP_AUTOMACAO: 'lances-pcp-automacao',
    LANCES_PCP_CONFIG_ITEM: 'lances-pcp-config-item',
    LANCES_PCP_LANCE_MANUAL: 'lances-pcp-lance-manual',
    LANCES_PCP_LISTA: 'lances-pcp-lista',
    LANCES_PCP_MINIMOS: 'lances-pcp-minimos',
    LANCES_PCP_PAINEIS: 'lances-pcp-paineis',
    LANCES_PCP_SALA: 'lances-pcp-sala',
    PAINEL_MEU_PAINEL: 'painel-meu-painel',
    PAINEL_NOVAS_OPORTUNIDADES: 'painel-novas-oportunidades',
    PREGOES_APLICAR_CATALOGO: 'pregoes-aplicar-catalogo',
    PREGOES_BAIXAR_NOVOS_PREGOES: 'pregoes-baixar-novos-pregoes',
    PREGOES_CADASTRO_MANUAL: 'pregoes-cadastro-manual',
    PREGOES_CONCORRENTES: 'pregoes-concorrentes',
    PREGOES_CONFIGURAR_IMPORTACAO: 'pregoes-configurar-importacao',
    PREGOES_DETALHE: 'pregoes-detalhe',
    PREGOES_DOCUMENTOS: 'pregoes-documentos',
    PREGOES_ESCOLHER_PRODUTO: 'pregoes-escolher-produto',
    PREGOES_EXCLUIR: 'pregoes-excluir',
    PREGOES_EXPORTAR_EXCEL: 'pregoes-exportar-excel',
    PREGOES_FILTROS: 'pregoes-filtros',
    PREGOES_GERAR_DOCUMENTO: 'pregoes-gerar-documento',
    PREGOES_IMPORTAR_PLANILHA: 'pregoes-importar-planilha',
    PREGOES_ITENS: 'pregoes-itens',
    PREGOES_LISTA: 'pregoes-lista',
    PREGOES_MODOS_VISUALIZACAO: 'pregoes-modos-visualizacao',
    PREGOES_NOTAS: 'pregoes-notas',
    PREGOES_PREENCHER_MINIMO: 'pregoes-preencher-minimo',
    PREGOES_PREENCHIMENTO_RAPIDO: 'pregoes-preenchimento-rapido',
    PREGOES_PROPOSTA_ABRIR: 'pregoes-proposta-abrir',
    PREGOES_PROPOSTA_AMM_LICITA: 'pregoes-proposta-amm-licita',
    PREGOES_PROPOSTA_BBMNET: 'pregoes-proposta-bbmnet',
    PREGOES_PROPOSTA_BLL: 'pregoes-proposta-bll',
    PREGOES_PROPOSTA_BNC: 'pregoes-proposta-bnc',
    PREGOES_PROPOSTA_COMPRASBR: 'pregoes-proposta-comprasbr',
    PREGOES_PROPOSTA_COMPRASNET: 'pregoes-proposta-comprasnet',
    PREGOES_PROPOSTA_COMPRASNET_DECLARACOES: 'pregoes-proposta-comprasnet-declaracoes',
    PREGOES_PROPOSTA_COMPRASNET_MARGEM_PREFERENCIA: 'pregoes-proposta-comprasnet-margem-preferencia',
    PREGOES_PROPOSTA_LICITACOES_E: 'pregoes-proposta-licitacoes-e',
    PREGOES_PROPOSTA_LICITACOES_E_2: 'pregoes-proposta-licitacoes-e-2',
    PREGOES_PROPOSTA_LICITANET: 'pregoes-proposta-licitanet',
    PREGOES_PROPOSTA_LICITAR_DIGITAL: 'pregoes-proposta-licitar-digital',
    PREGOES_PROPOSTA_PCP: 'pregoes-proposta-pcp',
    PREGOES_PROPOSTA_PRE_PREENCHIDA: 'pregoes-proposta-pre-preenchida',
    PREGOES_PROPOSTA_PUBLINEXO: 'pregoes-proposta-publinexo',
    PREGOES_SINCRONIZAR_RESULTADO: 'pregoes-sincronizar-resultado',
    PREGOES_SITUACAO_CORES: 'pregoes-situacao-cores',
    PRODUTOS_ANEXOS: 'produtos-anexos',
    PRODUTOS_CADASTRAR_EDITAR: 'produtos-cadastrar-editar',
    PRODUTOS_CADASTRAR_FORNECEDOR: 'produtos-cadastrar-fornecedor',
    PRODUTOS_CATALOGO: 'produtos-catalogo',
    PRODUTOS_CATMAT: 'produtos-catmat',
    PRODUTOS_EXCLUIR: 'produtos-excluir',
    PRODUTOS_FORNECEDORES: 'produtos-fornecedores',
    PRODUTOS_IMPORTAR_PLANILHA: 'produtos-importar-planilha',
    PRODUTOS_OPORTUNIDADES: 'produtos-oportunidades',
    PRODUTOS_OPORTUNIDADES_ITENS: 'produtos-oportunidades-itens',
    PRODUTOS_OPORTUNIDADES_PREPARAR_PROPOSTA: 'produtos-oportunidades-preparar-proposta',
    PRODUTOS_PALAVRAS_BUSCA: 'produtos-palavras-busca',
    PRODUTOS_SEMENTE_HISTORICO: 'produtos-semente-historico',
    PRODUTOS_SUGESTAO_NOS_ITENS: 'produtos-sugestao-nos-itens',
    PRODUTOS_VINCULAR_FORNECEDOR: 'produtos-vincular-fornecedor',
    SISTEMA_APARENCIA_MENU: 'sistema-aparencia-menu',
    SISTEMA_ASSISTENTE_IA: 'sistema-assistente-ia',
    SISTEMA_ATUALIZAR_APP: 'sistema-atualizar-app',
    SISTEMA_EMPRESA_ATIVA: 'sistema-empresa-ativa',
    SISTEMA_LOGIN: 'sistema-login',
    SISTEMA_MENU_CABECALHO: 'sistema-menu-cabecalho',
    SISTEMA_NOTIFICACOES: 'sistema-notificacoes',
    SISTEMA_NOVIDADES: 'sistema-novidades',
    SISTEMA_RECUPERAR_SENHA: 'sistema-recuperar-senha',
    SISTEMA_RECURSOS_DISPONIVEIS: 'sistema-recursos-disponiveis',
    SISTEMA_STATUS_SINCRONIA: 'sistema-status-sincronia',
    SISTEMA_TRANCAR_TELA: 'sistema-trancar-tela',
    USUARIO_PERFIL: 'usuario-perfil',
    USUARIO_PERFIL_LICENCAS_PAGAMENTO: 'usuario-perfil-licencas-pagamento',
    USUARIO_TROCA_SENHA: 'usuario-troca-senha',
});

/**
 * Botão "?" da página: slug com primary: true da rota. Rota ausente = sem botão
 * (/auth/logout não tem botão de página). Produtos e Lances só abrem para empresas liberadas.
 */
export const AJUDA_POR_ROTA = Object.freeze({
    '/': AJUDA_SLUGS.PAINEL_MEU_PAINEL,
    '/apps/alertas': AJUDA_SLUGS.ALERTAS_CENTRAL,
    '/apps/boletins': AJUDA_SLUGS.BOLETINS_LISTA,
    '/apps/busca': AJUDA_SLUGS.BUSCA_PESQUISAR,
    '/apps/calendar': AJUDA_SLUGS.CALENDARIO_PREGOES,
    '/apps/lances/bll': AJUDA_SLUGS.LANCES_BNC_BLL_LISTA,
    '/apps/lances/bnc': AJUDA_SLUGS.LANCES_BNC_BLL_LISTA,
    '/apps/lances/comprasnet': AJUDA_SLUGS.LANCES_COMPRASNET_LISTA,
    '/apps/lances/dispensa': AJUDA_SLUGS.LANCES_COMPRASNET_DISPENSA_SALA,
    '/apps/lances/pcp': AJUDA_SLUGS.LANCES_PCP_LISTA,
    '/apps/lances/pcp/lance': AJUDA_SLUGS.LANCES_PCP_SALA,
    '/apps/lances/pregao/lance': AJUDA_SLUGS.LANCES_COMPRASNET_PREGAO_SALA,
    '/apps/pregoes': AJUDA_SLUGS.PREGOES_LISTA,
    '/auth/erro-migration': AJUDA_SLUGS.SISTEMA_LOGIN,
    '/auth/lockscreen-boxed': AJUDA_SLUGS.SISTEMA_TRANCAR_TELA,
    '/auth/login-boxed': AJUDA_SLUGS.SISTEMA_LOGIN,
    '/auth/pass-recovery-boxed': AJUDA_SLUGS.SISTEMA_RECUPERAR_SENHA,
    '/auth/sistema-atualizado': AJUDA_SLUGS.SISTEMA_LOGIN,
    '/auth/troca-senha-boxed': AJUDA_SLUGS.SISTEMA_RECUPERAR_SENHA,
    '/configs/alertasgeral': AJUDA_SLUGS.CONFIG_ALERTAS,
    '/configs/celulares': AJUDA_SLUGS.CONFIG_CELULARES,
    '/configs/central': AJUDA_SLUGS.CONFIG_CENTRAL_EMPRESAS,
    '/configs/documentacao': AJUDA_SLUGS.CONFIG_DOCUMENTACAO_FINAL,
    '/configs/documentos': AJUDA_SLUGS.CONFIG_DOCUMENTOS_EMPRESA,
    '/configs/loginsportal': AJUDA_SLUGS.CONFIG_LOGINS_PORTAIS,
    '/configs/logssincronia': AJUDA_SLUGS.CONFIG_LOGS_SINCRONIA,
    '/configs/representados': AJUDA_SLUGS.CONFIG_REPRESENTADOS,
    '/apps/produtos': AJUDA_SLUGS.PRODUTOS_CATALOGO,
    '/apps/produtos/fornecedores': AJUDA_SLUGS.PRODUTOS_FORNECEDORES,
    '/apps/produtos/oportunidades': AJUDA_SLUGS.PRODUTOS_OPORTUNIDADES,
    '/index2': AJUDA_SLUGS.PAINEL_NOVAS_OPORTUNIDADES,
    '/users/profile': AJUDA_SLUGS.USUARIO_PERFIL,
    '/users/troca-senha': AJUDA_SLUGS.USUARIO_TROCA_SENHA,
});

/**
 * Telas com abas: o "?" da página abre o artigo da aba que está aberta.
 * Chave = rota; valor = { idDaAba: slug }. As abas Bootstrap (data-bs-toggle="tab") usam o id do link da aba
 * (AjudaPagina escuta o evento); as abas controladas pelo Vue chamam defineAjudaAba(rota, idDaAba).
 */
export const AJUDA_POR_ABA = Object.freeze({
    '/configs/alertasgeral': {
        'configer-tab': AJUDA_SLUGS.CONFIG_ALERTAS,
        'mobile-tab': AJUDA_SLUGS.CONFIG_ALERTAS_DISPOSITIVOS_MOBILE,
    },
    '/configs/central': {
        'empresas-tab': AJUDA_SLUGS.CONFIG_CENTRAL_EMPRESAS,
        'loginsportais-tab': AJUDA_SLUGS.CONFIG_LOGINS_PORTAIS,
        'declaracoes-tab': AJUDA_SLUGS.CONFIG_CENTRAL_DECLARACOES,
    },
    '/configs/documentacao': {
        timbre: AJUDA_SLUGS.CONFIG_DOCUMENTACAO_TIMBRE,
        resp: AJUDA_SLUGS.CONFIG_DOCUMENTACAO_RESPONSAVEIS,
        modelos: AJUDA_SLUGS.CONFIG_DOCUMENTACAO_MODELOS,
    },
});

// Aba aberta na tela atual (a rota guardada evita usar a aba de outra tela)
const abaAtiva = reactive({ rota: null, aba: null });

/** Informa a aba aberta da rota (aba = null volta ao artigo geral da tela). */
export const defineAjudaAba = (rota, aba) => {
    abaAtiva.rota = rota;
    abaAtiva.aba = aba || null;
};

/**
 * Slug do "?" da página. A rota /apps/busca atende dois itens do menu (Buscar e Favoritos);
 * no modo Favoritos abre o artigo dos favoritos.
 */
export const ajudaDaRota = (path, { buscaFavorito = false } = {}) => {
    if (path === '/apps/busca' && buscaFavorito) return AJUDA_SLUGS.BUSCA_FAVORITOS;
    if (abaAtiva.rota === path && abaAtiva.aba) {
        const slugAba = (AJUDA_POR_ABA[path] || {})[abaAtiva.aba];
        if (slugAba) return slugAba;
    }
    return AJUDA_POR_ROTA[path] || null;
};
